import { FC, useEffect, useState } from 'react';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import { FILE_TYPES } from '../../Form/form.validations';
import './FileRenderer.scss';

type FileProps = {
	field: IEntityContentField;
};

const FileRenderer: FC<FileProps> = ({ field }) => {
	const [zoomed, setZoomed] = useState<boolean>(false);
	const [imageSize, setImageSize] = useState<
		{ width: number; height: number } | undefined
	>();
	const [zoomedStyles, setZoomedStyles] = useState<
		{ width: number; height: number } | undefined
	>();
	const extention = field?.content?.split(/[#?]/)[0]?.split('.')?.pop()?.trim();
	const isImage =
		extention &&
		[
			FILE_TYPES.JPEG.key,
			FILE_TYPES.JPG.key,
			FILE_TYPES.PNG.key,
			FILE_TYPES.SVG.key,
		].includes(extention);
	const styles: {
		maxWidth?: string;
	} = {};
	if (field?.options?.maxWidth) {
		styles.maxWidth = `${field?.options?.maxWidth}px`;
	}
	useEffect(() => {
		if (isImage) {
			const img = new Image();
			img.src = field.content;
			img.onload = function () {
				setImageSize({ width: img.width, height: img.height });
			};
		}
	}, []);
	useEffect(() => {
		if (zoomed && imageSize) {
			const { width, height } = imageSize;
			const zoomedImageSize = {
				width,
				height,
			};
			if (window.innerWidth * 0.9 < width) {
				const adjustedWidth = window.innerWidth * 0.9;
				const adjustedHeight = (height * adjustedWidth) / width;
				zoomedImageSize.width = adjustedWidth;
				zoomedImageSize.height = adjustedHeight;
				if (window.innerHeight * 0.9 < adjustedHeight) {
					const secondAdjustedHeight = window.innerHeight * 0.9;
					const secondAdjustedWidth =
						(secondAdjustedHeight * adjustedWidth) / adjustedHeight;
					zoomedImageSize.width = secondAdjustedWidth;
					zoomedImageSize.height = secondAdjustedHeight;
				}
			}
			setZoomedStyles(zoomedImageSize);
		}
	}, [zoomed]);
	return isImage ? (
		<div className="FileRenderer">
			<div className="image-wrapper" onClick={() => setZoomed(!zoomed)}>
				{zoomed && zoomedStyles ? (
					<div
						style={{
							width: '100%',
							height: '100%',
							position: 'fixed',
							top: 0,
							left: 0,
							zIndex: 10000,
							background: 'rgba(122, 122, 122, 0.5)',
						}}
					>
						<img
							src={field.content}
							alt=""
							style={{
								width: zoomedStyles.width,
								height: zoomedStyles.height,
								position: 'fixed',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)',
								zIndex: 10001,
							}}
						/>
					</div>
				) : (
					<img src={field.content} alt="" style={styles} />
				)}

				<div className="overlay">
					<ZoomInIcon />
				</div>
			</div>
		</div>
	) : null;
};

export default FileRenderer;
